import { Flex } from 'reflexbox';
import OrderIcon from '~/assets/img/order.svg';
import { NewTable, Table } from '~/components';
import { IconWiFiRealTime } from '../../../UnitDetailDACsDAMs/components/MosaicListItem/styles';
import { t } from 'i18next';
import {
  TransparentLink, TableItemCell,
} from '../../styles';
import { UtilityIcon } from '~/icons';
import { formatRssiIcon, getUtilitiesStatus } from '../MosaicCard';
import { acessorUtilities } from '~/pages/Analysis/DMTs/AcessorUtilities';
import { useEffect, useState } from 'react';

function formatFeedback(props) {
  if (!props.PORT) return '-';
  if (['Elevator', 'Escalator'].includes(props.APPLICATION)) return `P${props.PORT - 1}`;
  return `F${props.PORT}`;
}

function returnLinkUtility(utilityInfo: any) {
  const linkUtility = `/analise/utilitario/${utilityInfo.APPLICATION === 'Illumination' ? `iluminacao/${utilityInfo.ILLUMINATION_ID}` : `${utilityInfo.APPLICATION?.toLowerCase().replace(' ', '')}/${utilityInfo.ID}`}/informacoes`;
  return linkUtility;
}

function getNobreakColumns() {
  return [
    {
      name: 'name',
      value: t('nome'),
      width: '30%',
      accessor: 'NAME',
      render: (props) => (
        <TableItemCell>
          <Flex style={{ fontSize: '14px' }} alignItems="center">
            <Flex style={{ width: '50px' }} justifyContent="center">
              {(acessorUtilities[props.APPLICATION]?.icon) || <UtilityIcon width="25px" height="20px" />}
            </Flex>
            <Flex flexDirection="column">
              <TransparentLink to={returnLinkUtility(props)}>
                {props.NAME}
              </TransparentLink>
              <div style={{ fontSize: '11.8px', color: '#7B7B7B' }}>
                {props.DAT_CODE && (
                  <TransparentLink to={returnLinkUtility(props)}>
                    <span>{`${props.DAT_CODE} /`}</span>
                  </TransparentLink>
                )}
                <TransparentLink style={{ minHeight: 14 }} to={`/analise/dispositivo/${props.DMT_CODE || props.DAL_CODE || props.DAM_ILLUMINATION_CODE}/informacoes`}>
                  <span>{props.DMT_CODE || props.DAL_CODE || props.DAM_ILLUMINATION_CODE || ''}</span>
                </TransparentLink>
              </div>
            </Flex>
          </Flex>
        </TableItemCell>
      ),
    },
    {
      name: 'status',
      value: t('status'),
      width: '30%',
      accessor: 'status',
      render: (props) => (
        <TableItemCell>
          <Flex style={{ fontSize: '14px' }}>
            {getUtilitiesStatus(props, props.telemetry)}
          </Flex>
        </TableItemCell>
      ),
    },
    {
      name: 'port',
      value: `Feedback/${t('porta')}`,
      width: '20%',
      accessor: 'PORT',
      render: (props) => <TableItemCell>{formatFeedback(props)}</TableItemCell>,
    },
    {
      name: 'conection',
      value: t('conexao'),
      width: '10%',
      accessor: 'rssi',
      render: (props) => (
        <TableItemCell>
          <IconWiFiRealTime style={{ marginLeft: '6px' }}>
            {formatRssiIcon(props.telemetry)}
          </IconWiFiRealTime>
        </TableItemCell>
      ),
    },
  ];
}

export const UtilityTable = ({ filterNobreaks, telemetries, tab }): React.ReactElement => {
  const nobreakColumns = getNobreakColumns();
  const [utilitiesListFiltered, setUtilitiesListFiltered] = useState(filterNobreaks);
  const [order, setOrder] = useState<''>('');
  const [sort, setSort] = useState('+');
  useEffect(() => {
    setUtilitiesListFiltered(filterNobreaks.map((utility) => ({ ...utility, PORT: utility.PORT || utility.DAL_PORT, telemetry: telemetries[utility.DAL_CODE || utility.DMT_CODE || utility.DAM_ILLUMINATION_CODE] })));
  }, [filterNobreaks]);
  return (
    <NewTable
      styledPagination
      data={utilitiesListFiltered}
      columns={nobreakColumns}
      pageSize={20}
      noSearchBar
      verifyMobile
      order={order}
      setOrder={setOrder}
      sort={sort}
      setSort={setSort}
    />
  );
};
